import React, { Component } from "react"
import { Grid, Row, Col, Image } from "react-bootstrap"
import ReactPlayer from "react-player"
import Lazyload from "react-lazyload-fadein"
import Lightbox from "lightbox-react"
import "lightbox-react/style.css"
import { breakpoint } from "../config.prod"
import { chunk } from "../helpers/utils.js"

import Sidebar from "../components/Sidebar.js"
import { getStory, getAttachment } from "../helpers/api.js"
import { cdnUrl } from "../config.prod.json"
import { Seo } from "../components/Seo.js"

class Story extends Component {
  constructor(props) {
    super(props)
    this.state = {
      projectName: "",
      description: "",
      body: "",
      attachments: [],
      showLightbox: false,
      photoIndex: 0,
      isCoverLoaded: false,
      loaded: false
    }
  }

  componentDidMount() {
    const alias = this.props.location.pathname.split("/")[2]
    getStory(alias)
      .then(({ projectName, description, body, attachments, images }) => {
        if(images) {
          attachments = images
        }
        this.setState({
          projectName,
          description,
          body
        })
        return Promise.all(attachments.map(getAttachment))
      })
      .then(data => {
        const attachments = data.filter(e => !e.err).map(({ PK: alias, body, shortDescription, contentType = "image", link = "", thumb, err }, index) => {
          if(!thumb) {
            thumb = `${cdnUrl}/thumbs/${alias.replace("attachments-", "")}.jpg`
          }

          return ({
            index,
            alias,
            body,
            shortDescription,
            contentType,
            link,
            thumb
          })
        })

        this.setState({
          attachments,
          loaded: true
        })

      })
  }

  render() {
    const { photoIndex, attachments, showLightbox, isCoverLoaded, projectName, description, body, loaded } = this.state
    const lightboxImages = attachments.map(({ alias, contentType = "image", link }) => {
      if(contentType === "video") return (
        <div className = "player-lightbox">
          <ReactPlayer
            className = "video-lightbox"
            // light = { true }
            url = { link }
            controls = { true }
          />
        </div>
      )
      else return `${cdnUrl}/photos/${alias}.jpg`
    })
    return (
      <Grid fluid>
        <Seo title={projectName} description={description} type="article" image={ attachments[0] && attachments[0].contentType && attachments[0].contentType === "image" && `${cdnUrl}/photos/${attachments[0].alias}.jpg`}></Seo>
        <Row>
          <Col md = { 1 }>
            <Sidebar />
          </Col>
          <Col md = { 7 }>
            {
              showLightbox &&
                <Lightbox
                  className = { "lightbox" }
                  enableZoom = { false }
                  mainSrc = { lightboxImages[photoIndex] }
                  nextSrc = { lightboxImages[(photoIndex + 1) % lightboxImages.length] }
                  prevSrc = { lightboxImages[(photoIndex + lightboxImages.length - 1) % lightboxImages.length] }
                  onCloseRequest = { () => this.setState({ showLightbox: false }) }
                  imageCaption = { attachments[photoIndex].shortDescription }
                  onMovePrevRequest = { () =>
                    this.setState({
                      photoIndex: (photoIndex + lightboxImages.length - 1) % lightboxImages.length
                    })
                  }
                  onMoveNextRequest = { () =>
                    this.setState({
                      photoIndex: (photoIndex + 1) % attachments.length
                    })
                  }
                />
            }
            {
              loaded ?
                (
                  attachments[0].contentType && attachments[0].contentType === "image" &&
                <Lazyload>
                  {
                    onLoad => (
                      <Image
                        responsive
                        className = { "cover" }
                        onLoad = {() => {
                          onLoad()
                          this.setState({ isCoverLoaded: true })
                        }}
                        src = { `${cdnUrl}/photos/${attachments[0].alias}.jpg` }
                        alt = { attachments[0].shortDescription }
                      />
                    )
                  }
                </Lazyload>
                ) ||
              (
                attachments[0].contentType && attachments[0].contentType === "video" &&
                <ReactPlayer
                  url = { attachments[0].link }
                  controls = { true }
                  onReady = {() => this.setState({ isCoverLoaded: true }) }
                />
              ) ||
              (
                <h3 style = {{ color: "red" }}>Something went wrong</h3>
              )
                :
                <p>Loading...</p>
            }
            {
              isCoverLoaded &&
              <section className = { "story-overview" }>
                <h1>{ projectName }</h1>
                <h2>{ description }</h2>
                <div className={"body"} dangerouslySetInnerHTML={{ __html: body }}>

                </div>
                {
                  attachments.slice(1, 5).map(({ index, alias, body, shortDescription, link = "", contentType = "image", thumb }) => (
                    contentType === "image" &&

                      <section className = { "story-secondary-image" } key = { `secondary-image-${index}` }>
                        <Lazyload>
                          {
                            onLoad => (
                              <Image
                                responsive
                                className = { "body-image" }
                                onLoad = { onLoad }
                                src = { `${cdnUrl}/${window.innerWidth > breakpoint ? "photos" : "medium"}/${alias}.jpg` }
                                alt = { shortDescription }
                              />
                            )
                          }
                        </Lazyload>
                        <div className = { "body" }>
                          { body }
                        </div>
                      </section>
                  )
                    ||
                    <section className = { "story-secondary-image" } key = { `secondary-image-${index}` }>
                      <ReactPlayer
                        url = { link }
                        controls = { true }
                      />
                      <div className = { "body" }>
                        { body }
                      </div>
                    </section>
                  )
                }
                <section className = { "camera-roll" }>
                  <h3>Camera roll</h3>
                  <Grid>
                    {
                      chunk(attachments, 4).map((row, rowIndex) => (
                        <Row key = { `camera-roll-row-${rowIndex}` }>
                          {
                            row.map((data) => {
                              const { index, shortDescription, thumb, contentType } = data
                              return <Col md = { 3 } key = { `camera-roll-col-${index}` }>
                                {
                                  <Lazyload>
                                    {
                                      onLoad => (
                                        <Image
                                          responsive
                                          className = { "camera-roll-image" }
                                          onLoad = { onLoad }
                                          src = { thumb }
                                          alt = { shortDescription }
                                          onClick = { () => this.setState({
                                            showLightbox: true,
                                            photoIndex: index
                                          })}
                                        />
                                      )
                                    }
                                  </Lazyload>

                                }
                              </Col>
                            })
                          }
                        </Row>
                      ))
                    }
                  </Grid>
                </section>
              </section>
            }
          </Col>
        </Row>
      </Grid>
    )
  }
}

export default Story



// WEBPACK FOOTER //
// ./src/containers/Story.js